<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
	<path
		fill-rule="evenodd"
		clip-rule="evenodd"
		d="M10.2519 11.9995L15.3209 6.50847C15.6019 6.20347 15.5829 5.72947 15.2789 5.44847C14.9749 5.16847 14.4999 5.18647 14.2189 5.49147L8.21094 11.9995L14.2189 18.5085C14.3669 18.6685 14.5679 18.7495 14.7699 18.7495C14.9519 18.7495 15.1349 18.6835 15.2789 18.5505C15.5829 18.2695 15.6019 17.7955 15.3219 17.4915L10.2519 11.9995Z"
		fill="currentColor"
	/>
</svg>
